import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { Tag, TagColor } from '../models';

@Injectable()
export abstract class TagsService {
    abstract changeTagPriorities(tags: Tag[]): Promise<void>;

    abstract createTag(name: string, color: TagColor): Promise<Tag>;

    abstract updateTag(tagId: string, data: { name: string; color: TagColor; disabled?: boolean }): Promise<void>;

    abstract assignOperatorTagsToTicket(ticketId: string, tags: Tag[]): Promise<any>;

    abstract tags(): Observable<Tag[]>;

    abstract tag(id: string): Promise<Tag>;
}
